document.addEventListener("DOMContentLoaded", function () {
  "use strict";

  /* FAQ accordion */
  document.querySelectorAll("[data-faq]").forEach(function (root) {
    root.querySelectorAll("[data-faq-item]").forEach(function (item) {
      var button = item.querySelector("[data-faq-toggle]");
      var panel = item.querySelector("[data-faq-panel]");
      if (!button || !panel) return;
      button.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        root.querySelectorAll("[data-faq-item]").forEach(function (other) {
          other.classList.remove("is-open");
          var otherBtn = other.querySelector("[data-faq-toggle]");
          var otherPanel = other.querySelector("[data-faq-panel]");
          if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
          if (otherPanel) otherPanel.hidden = true;
        });
        if (!open) {
          item.classList.add("is-open");
          button.setAttribute("aria-expanded", "true");
          panel.hidden = false;
        }
      });
    });
  });

  var cartRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function closeColorDropdown(dd) {
    if (!dd) return;
    dd.classList.remove("is-open");
    var trigger = dd.querySelector("[data-color-dropdown-trigger]");
    var panel = dd.querySelector("[data-color-dropdown-panel]");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (panel) panel.hidden = true;
  }

  function initColorDropdowns(root) {
    var scope = root || document;
    scope.querySelectorAll("[data-color-dropdown]").forEach(function (dd) {
      if (dd.dataset.colorDropdownInit) return;
      dd.dataset.colorDropdownInit = "1";

      var select = dd.querySelector("[data-bundle-color-select]");
      var trigger = dd.querySelector("[data-color-dropdown-trigger]");
      var label = dd.querySelector("[data-color-dropdown-label]");
      var panel = dd.querySelector("[data-color-dropdown-panel]");
      var options = dd.querySelectorAll("[data-color-option]");
      if (!select || !trigger || !panel) return;

      function setValue(value, optionBtn, silent) {
        var empty = !value;
        select.value = empty ? "" : value;
        dd.classList.toggle("color-dropdown--empty", empty);
        if (label) {
          if (empty) label.textContent = "Elegir color";
          else if (optionBtn) label.textContent = optionBtn.dataset.colorName || value;
          else label.textContent = value;
        }
        options.forEach(function (opt) {
          var on = optionBtn ? opt === optionBtn : opt.dataset.value === value;
          opt.classList.toggle("is-selected", on);
          opt.setAttribute("aria-selected", on ? "true" : "false");
        });
        if (!silent) select.dispatchEvent(new Event("change", { bubbles: true }));
      }

      dd.applyColorValue = function (value, silent) {
        var match = null;
        options.forEach(function (opt) {
          if (opt.dataset.value === value) match = opt;
        });
        setValue(value || "", match, silent);
      };

      trigger.addEventListener("click", function (e) {
        e.preventDefault();
        var willOpen = !dd.classList.contains("is-open");
        scope.querySelectorAll("[data-color-dropdown].is-open").forEach(closeColorDropdown);
        if (!willOpen) return;
        dd.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        panel.hidden = false;
      });

      options.forEach(function (opt) {
        opt.addEventListener("click", function () {
          if (opt.disabled) return;
          setValue(opt.dataset.value, opt, false);
          closeColorDropdown(dd);
        });
      });
    });

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-color-dropdown]")) return;
      scope.querySelectorAll("[data-color-dropdown].is-open").forEach(closeColorDropdown);
    });
  }

  function shopifyCartErrorMessage(err) {
    if (!err) return "No se pudo añadir al carrito. Inténtalo de nuevo.";
    if (typeof err.description === "string") return err.description;
    if (typeof err.message === "string") return err.message;
    return "No se pudo añadir al carrito. Inténtalo de nuevo.";
  }

  /* Product bundle picker */
  var form = document.getElementById("product-form");
  if (form && form.querySelector("[data-bundle-list]")) {
    var cfg = window.TapgoProductForm || {};
    var bundleList = form.querySelector("[data-bundle-list]");
    var variantsJson = document.querySelector("[data-product-variants-json]");
    var variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
    var colorOptionIndex = parseInt(bundleList.dataset.colorOptionIndex, 10) || 0;
    var qtyInput = form.querySelector("[data-quantity]");
    var priceEl = form.querySelector("[data-product-price]");
    var compareEl = form.querySelector("[data-product-compare]");
    var submitBtn = form.querySelector("[data-add-to-cart]");
    var addLabel = form.querySelector("[data-add-to-cart-label]");
    var adding = false;

    function normalizeColor(value) {
      return value == null ? "" : String(value).trim().toLowerCase();
    }

    function findVariantByColor(colorValue) {
      if (!colorValue) return null;
      var target = normalizeColor(colorValue);
      return variants.find(function (variant) {
        return normalizeColor(variant.options[colorOptionIndex]) === target;
      });
    }

    function getSelectedCard() {
      return form.querySelector("[data-bundle-option].is-selected");
    }

    function getLineItemsFromCard(card) {
      var selects = card.querySelectorAll("[data-bundle-color-select]");
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var byVariant = {};

      if (!selects.length) {
        var fallback =
          variants.find(function (v) {
            return v.available;
          }) || variants[0];
        if (fallback) {
          byVariant[fallback.id] = {
            id: fallback.id,
            quantity: qty,
            properties: { _tapgo_bundle: "1" },
          };
        }
        return Object.keys(byVariant).map(function (key) {
          return byVariant[key];
        });
      }

      selects.forEach(function (sel) {
        if (!sel.value) return;
        var variant = findVariantByColor(sel.value);
        if (!variant) return;
        var id = String(variant.id);
        if (!byVariant[id]) {
          byVariant[id] = {
            id: variant.id,
            quantity: 0,
            properties: { _tapgo_bundle: "1", Color: sel.value },
          };
        }
        byVariant[id].quantity += 1;
      });

      return Object.keys(byVariant).map(function (key) {
        return byVariant[key];
      });
    }

    function updateUI() {
      var card = getSelectedCard();
      if (!card) return;
      var qty = parseInt(card.dataset.qty, 10) || 1;
      var totalLabel = card.dataset.totalLabel || "";
      var compareLabel = (card.dataset.compareLabel || "").trim();
      var showCompare = qty > 1 && compareLabel.length > 0;

      if (qtyInput) qtyInput.value = qty;
      if (priceEl) priceEl.textContent = totalLabel;

      if (compareEl) {
        if (showCompare) {
          compareEl.textContent = compareLabel;
          compareEl.hidden = false;
        } else {
          compareEl.textContent = "";
          compareEl.hidden = true;
        }
      }

      var items = getLineItemsFromCard(card);
      var selects = card.querySelectorAll("[data-bundle-color-select]");
      var filledSlots = 0;
      selects.forEach(function (sel) {
        if (sel.value) filledSlots += 1;
      });

      var needsColors = selects.length > 0;
      var canAdd =
        items.length > 0 &&
        (!needsColors || filledSlots === qty || (filledSlots > 0 && filledSlots <= qty));

      if (needsColors && filledSlots === 0) canAdd = false;

      if (!needsColors) {
        canAdd =
          items.length > 0 &&
          items.every(function (item) {
            var v = variants.find(function (x) {
              return x.id === item.id;
            });
            return v && v.available;
          });
      }

      if (submitBtn) submitBtn.disabled = !canAdd || adding;
      if (addLabel) {
        if (!canAdd) addLabel.textContent = cfg.soldOutLabel || "Agotado";
        else if (needsColors && filledSlots > 0 && filledSlots < qty)
          addLabel.textContent = "Agregar " + filledSlots + " al carrito";
        else addLabel.textContent = cfg.addToCartLabel || "Agregar al carrito";
      }
    }

    function selectBundle(card) {
      form.querySelectorAll("[data-bundle-option]").forEach(function (el) {
        var on = el === card;
        el.classList.toggle("is-selected", on);
        var btn = el.querySelector("[data-bundle-select]");
        if (btn) btn.setAttribute("aria-pressed", on ? "true" : "false");
      });
      updateUI();
    }

    form.querySelectorAll("[data-bundle-select]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        selectBundle(btn.closest("[data-bundle-option]"));
      });
    });

    form.querySelectorAll("[data-bundle-color-select]").forEach(function (sel) {
      sel.addEventListener("change", updateUI);
    });

    initColorDropdowns(form);
    updateUI();

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var card = getSelectedCard();
      if (!card || !submitBtn || submitBtn.disabled || adding) return;

      var items = getLineItemsFromCard(card);
      if (!items.length) return;

      adding = true;
      submitBtn.disabled = true;
      if (addLabel) addLabel.textContent = "Añadiendo…";

      fetch(cartRoot + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function () {
          window.location.href = cfg.cartUrl || cartRoot + "cart";
        })
        .catch(function (err) {
          adding = false;
          updateUI();
          window.alert(shopifyCartErrorMessage(err));
        });
    });
  }
});
